// The sign-in page is shown before anyone is signed in, so it names no organization (approved sign-in mockup,
// docs/design/mockups/sign-in.html).
export const LOGIN_COPY = {
  headline: 'Every call, from first ring to resolution.',
  intro: 'Call routes, service levels, and what callers needed, from Microsoft Teams Phone call records. Read-only access to your Teams data.',
  account: 'Use your Microsoft work account.',
};

export const LOGIN_ROUTE_STEPS = [
  { color: '#9085e9', kind: 'Auto attendant', name: 'Main Line', detail: '0:18' },
  { color: '#3a9be0', kind: 'Queue', name: 'Owner Services', detail: '0:41 wait' },
  { color: '#1baf7a', kind: 'Agent', name: 'Maria Delgado', detail: '5:53 talk' },
  { color: '#9aa6b6', kind: 'Outcome', name: 'Resolved', detail: 'No transfer' },
];

export const LOGIN_EXAMPLE_COMMUNITY = 'Maple Ridge Estates';
